import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './app/App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');

// Check if the container has prerendered content (from react-snap)
if (container && container.hasChildNodes()) {
  // Hydrate existing prerendered content
  ReactDOM.hydrateRoot(container, 
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Create new root for fresh loads
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
